import { styled } from '@/styled-system/jsx';

// Helper function to apply no-user-select styles
const noUserSelectStyles = {
  WebkitTouchCallout: 'none',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  userSelect: 'none',
  WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
};

export const MapWrapper = styled('section', {
  base: {
    ...noUserSelectStyles,
    height: '100%',
    width: '100%',
    position: 'absolute',
    right: '0px',
    left: '0px',
    md: {
      display: 'inline-block',
      paddingRight: 'sidebarMd',
      top: '0',
    },
    xxl: {
      paddingRight: 'sidebarXl',
    },
  },
});

export const StaticMapContainer = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
});

export const StaticMapFixed = styled('div', {
  base: {
    flexShrink: '0',
    position: 'relative',
  },
});

export const StaticMapImage = styled('img', {
  base: {
    transform: 'scale(2)',
    imageRendering: 'pixelated',
    alignSelf: 'center',
  },
});
